import Link from 'next/link'
import React from 'react'
import { FaBars } from 'react-icons/fa'
import styles from './styles.module.scss'
import { entriesMobile } from '@components/sign-in-button/data'
import { useRouter } from 'next/router'
import classNames from 'classnames'
import { SideBarHelpMe } from '../side-bar-help-me'
import { useAuth } from 'context/auth/auth-context'

export const FlatMenu = () => {
  const router = useRouter()
  const { hasPermission } = useAuth()

  return (
    <div className={`group ${styles.dropdownWeb}`}>
      <FaBars />
      <ul className="group-hover:block">
        {entriesMobile().map(
          entry =>
            (!entry.roles || hasPermission(entry.roles)) && (
              <li
                key={entry.label}
                className={classNames({
                  'font-bold text-gray-900': router.pathname.includes(entry.to)
                })}
              >
                <Link href={entry.to}>{entry.label}</Link>
              </li>
            )
        )}
        <li className="pointer-events-none">
          <SideBarHelpMe />
        </li>
      </ul>
    </div>
  )
}
